export default "/_next/static/images/product-icon-12557f3cca74875fe577cd311392f2c8.svg";